import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

export const saveScheduleDraft = api(async function saveScheduleDraft({ projectId, scheduleId, draft }) {
    return mutate(
        gql`
            mutation SaveScheduleDraft($projectId: String!, $scheduleId: String!, $draft: ScheduleDraftInput!) {
                saveScheduleDraft(projectId: $projectId, scheduleId: $scheduleId, draft: $draft)
            }
        `,
        { projectId, scheduleId, draft },
        { returns: "saveScheduleDraft" }
    )
})
